import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AdvancedForm from '../AdvancedForm/AdvancedForm';
import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';
import { inviteCode } from '@portal/actions/onboarding';
import { translate } from '@portal/services/i18n';
import useReduxState from '@portal/hooks/useReduxState';

interface RecommendationProps {
  onFormChange: (key: string, val: string | boolean) => void;
}

const Recommendation = ({ onFormChange }: RecommendationProps) => {
  const [code, setCode] = useState('');
  const [codeErrorText, setCodeErrorText] = useState(
    translate('PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.LABEL_CODE')
  );
  const dispatch = useDispatch();

  const {
    onboarding: { inviteResponse },
  } = useReduxState();

  const validateCode = () => {
    dispatch(inviteCode(code));
  };

  useEffect(() => {
    if (code.length === 6) {
      validateCode();
    } else {
      onFormChange('referralCode', code);
      onFormChange('indicationCodeValidation', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  useEffect(() => {
    if (inviteResponse) {
      const isValid = inviteResponse?.isValid ?? false;
      onFormChange('indicationCodeValidation', isValid);
      if (isValid) {
        onFormChange('referralCode', code);
      } else {
        setCodeErrorText(
          `${translate(
            'PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.CODE_PERSON.ERROR'
          )}`
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteResponse, codeErrorText, code]);

  return (
    <div className="recommendation">
      <div className="recommendation__header">
        <p>
          {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.TITLE')}
        </p>
        <p>{translate('PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.INFO')}</p>
      </div>
      <AdvancedForm>
        <Row className="recommendation__wrapper">
          <Col className="recommendation__wrapper__item">
            <AdvancedInput
              label={translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.TAB_LABEL'
              )}
              variant="standard"
              value={code}
              onChange={(value) => setCode(value)}
              maxLength={6}
            />
          </Col>
        </Row>
      </AdvancedForm>

      {inviteResponse?.isValid ? (
        <p>
          {inviteResponse.name}
          {translate(
            'PAGES.AUTH.REGISTER.ONBOARD.PF.RECOMMENDATION.CODE_PERSON.TITLE'
          )}
        </p>
      ) : (
        <p>{codeErrorText}</p>
      )}
    </div>
  );
};

export default Recommendation;
